import { Property } from 'shared-types/Property';
import { z } from 'zod';

const guestSchema = z.object({
  title: z.string().trim().min(1, 'required'),
  firstName: z.string().trim().min(1, 'required'),
  lastName: z.string().trim().min(1, 'required'),
  gender: z.string().trim().min(1, 'required'),
  externalSpaId: z.union([z.string(), z.number()]).nullable().optional(),
  loggedInUser: z.object({ id: z.number() }).optional(),
  selectedGuestId: z.string().optional(),
});

export const spaClassBookingFormSchema = z.object({
  guests: z.array(guestSchema).min(1, 'required'),
});

export type SpaClassBookingFormValues = z.infer<typeof spaClassBookingFormSchema>;

export type SpaClassBookingV2Props = {
  id: number;
  property: Property;
  language: string;
  startDateTime?: string;
};
